var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFourteen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #1f3060;\n      }\n\n      .cls-2 {\n        fill: #0f2346;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        fill: #ccc;\n      }\n\n      .cls-5 {\n        fill: #eaeaea;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rent"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Delivery_truck"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M697.3,248.65v557.35h-267.53c0-49.25-39.93-89.18-89.18-89.18s-89.18,39.93-89.18,89.18h-111.47c-12.31,0-22.29-9.98-22.29-22.29V248.65c0-12.31,9.98-22.29,22.29-22.29h535.06c12.31,0,22.29,9.98,22.29,22.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1054,672.24v133.76h-89.18c0-49.25-39.93-89.18-89.18-89.18s-89.18,39.93-89.18,89.18h-89.18v-468.17h147.14c18.77,0,35.53,11.77,41.91,29.43l78.47,215.81c49.25,0,89.18,39.93,89.18,89.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1054,672.24v89.18h-101.21c-24.71-42.6-79.28-57.1-121.88-32.39-13.43,7.79-24.6,18.96-32.39,32.39-31.27,0-56.63-25.35-56.63-56.63h0v-366.96h102.55c18.77,0,35.53,11.77,41.91,29.43l78.47,215.81c49.25,0,89.18,39.93,89.18,89.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M798.73,761.42c-1.89,3.25-3.6,6.6-5.13,10.03,1.27-3.51,2.92-6.87,4.9-10.03h.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M957.69,771.45c-1.53-3.43-3.24-6.78-5.13-10.03,2.06,3.15,3.78,6.51,5.13,10.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M964.82,583.06h-178.35v-245.23h57.96c18.77,0,35.53,11.77,41.91,29.43l78.47,215.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M964.82,583.06c-71.12,2.71-130.96-52.75-133.67-123.86-.06-1.59-.09-3.18-.09-4.78v-116.6h13.38c18.77,0,35.53,11.77,41.91,29.43l78.47,215.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M697.3,248.65v512.76h-279.57c-24.71-42.6-79.28-57.1-121.88-32.39-13.43,7.79-24.6,18.96-32.39,32.39-43.59,0-78.92-35.33-78.92-78.92h0V226.36h490.47c12.31,0,22.29,9.98,22.29,22.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M697.3,605.36v44.59h-423.59c-12.31,0-22.29-9.98-22.29-22.29s9.98-22.29,22.29-22.29h423.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M429.77,806c0,49.25-39.93,89.18-89.18,89.18s-89.18-39.93-89.18-89.18,39.93-89.18,89.18-89.18,89.18,39.93,89.18,89.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M405.91,866.64c-60.86,66.88-171.44,8.25-152.94-76.69,61.09-66.21,171.44-8.03,152.94,76.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M964.82,806c0,49.25-39.93,89.18-89.18,89.18s-89.18-39.93-89.18-89.18,39.93-89.18,89.18-89.18,89.18,39.93,89.18,89.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M940.97,866.64c-60.86,66.88-171.44,8.25-152.94-76.69,61.09-66.21,171.44-8.03,152.94,76.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M362.89,806c0-12.31-9.98-22.29-22.29-22.29s-22.29,9.98-22.29,22.29,9.98,22.29,22.29,22.29,22.29-9.98,22.29-22.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M897.94,806c0-12.31-9.98-22.29-22.29-22.29s-22.29,9.98-22.29,22.29,9.98,22.29,22.29,22.29,22.29-9.98,22.29-22.29Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M251.42,382.42H50.77c-12.31,0-22.29-9.98-22.29-22.29s9.98-22.29,22.29-22.29h200.65c12.31,0,22.29,9.98,22.29,22.29s-9.98,22.29-22.29,22.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M229.12,516.18H73.06c-12.31,0-22.29-9.98-22.29-22.29s9.98-22.29,22.29-22.29h156.06c12.31,0,22.29,9.98,22.29,22.29s-9.98,22.29-22.29,22.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M184.53,649.94h-89.18c-12.31,0-22.29-9.98-22.29-22.29s9.98-22.29,22.29-22.29h89.18c12.31,0,22.29,9.98,22.29,22.29s-9.98,22.29-22.29,22.29Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M385.18,538.47c-12.26,0-9.59,0-82.71-73.35-8.74-8.74-8.74-22.92,0-31.66,8.74-8.74,22.92-8.74,31.66,0l52.17,52.39,140.45-120.39c9.36-8,23.43-6.91,31.43,2.45,8,9.36,6.91,23.43-2.45,31.43-168.54,144.47-158.73,139.11-170.55,139.11h0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFourteen);
export default __webpack_public_path__ + "static/media/fourteen.98d2e5996d477b729c490859d480f1f0.svg";
export { ForwardRef as ReactComponent };